import { render, staticRenderFns } from "./UkerportalKereso3.vue?vue&type=template&id=2d385591&"
import script from "./UkerportalKereso3.vue?vue&type=script&lang=js&"
export * from "./UkerportalKereso3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports